<template>
  <section v-if="status" class="modal">
    <section class="modal__content">
      <Header />

      <component :is="componentName" @changeComponent="changeComponent" />
    </section>
  </section>
</template>

<script>
import Header from "./complements/Header.vue";
import Options from "./complements/Options.vue";
import Doubt from "./complements/Doubt.vue";
import Account from "./complements/Account.vue";
import Message from "./complements/Message.vue";
import { mapGetters } from "vuex";

export default {
  name: "ChatComponent",

  data: () => ({
    componentName: "Options",
  }),

  computed: {
    ...mapGetters({
      status: "getHelpModalStatus",
    }),
  },

  components: {
    Header,
    Options,
    Doubt,
    Account,
    Message,
  },

  methods: {
    changeComponent(componentName) {
      this.componentName = componentName;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .modal__content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    background: #ffffff;
    width: 420px;
    border-radius: 16px;

    .header {
      display: flex;
      justify-content: space-between;

      strong {
        font-size: 14px;
        font-weight: 600;
      }
    }

    .body {
      display: flex;
      flex-direction: column;
      text-align: center;
      gap: 8px;
      font-size: 14px;
      width: 100%;
      padding: 0;

      strong {
        font-size: 14px;
        font-weight: 600;
      }

      .form {
        width: 100%;
      }
    }

    .footer {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }
  }
}
</style>
